import React from 'react';
import styles from './type-header.module.scss';
import { useMediaQuery } from 'react-responsive';
import Header from '../../../../components/shared/header';
import { NavigationSelector } from '../../../../components/shared/navigation-selector';
import { IconButton } from '@mui/material';
import { SVGS } from '../../../../assets/images';
import CreateNewButtonV2 from '../../../../components/shared/create-new-button-v2';
import classNames from 'classnames';
import { useAppSelector } from '../../../../hooks/hooks';
import { getVisibleTypeTabs } from '../../tabs';

interface Props {
    onMobileFilterClick: () => void;
    onCreateNew: () => void;
    isEmpty: boolean;
    isFilterOpen: boolean;
    canCreate?: boolean;
    onMobileFilterClose?: () => void;
    loading?: boolean;
}

export function TypeHeader({
    onMobileFilterClick,
    onCreateNew,
    isEmpty,
    isFilterOpen,
    canCreate = true,
    onMobileFilterClose,
    loading,
}: Props) {
    const isMobile = useMediaQuery({ maxWidth: 1000  });
    const profile = useAppSelector(store => store.profile);
    const typesState = useAppSelector(store => store.types);
    const formOptions = getVisibleTypeTabs(profile, {
        project: typesState.projects.permissions,
        shift: typesState.shifts.permissions,
        absence: typesState.absences.permissions,
        tag: typesState.tags.permissions,
    }).map((option) => ({
        value: option.key,
        label: option.label,
        path: option.path,
    }));
    return (
        <div className={styles.container}>
            <div className={styles.containerItem}>
                <Header headerLocalizationId='type' loading={loading}>
                    <NavigationSelector options={formOptions} />
                </Header>
            </div>
            <div className={styles.containerItem}>
                {   
                    isMobile
                        ? 
                        !isEmpty
                            ?
                            <IconButton
                                aria-label='filterIconButton'
                                onClick={() => {
                                    if (isFilterOpen) {
                                        onMobileFilterClose?.();
                                    }
                                    onMobileFilterClick();
                                }}
                                className={styles.filterButton}>
                                <SVGS.FilterIcon className={classNames({[styles.active]: isMobile && isFilterOpen})} />
                            </IconButton>
                            : <></>
                        : canCreate ? <CreateNewButtonV2 onClick={onCreateNew} /> : null
                }
            </div>
        </div>
    );
}
